@if ( data$ | async; as component) {
  @if (items$ | async; as items) {
    <div class="tab-item" [style]="'background-color :'+ component.background">
      <div ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
        @for (item of items; track item; let i = $index) {
          <div [ngbNavItem]="i+1">
            @switch (component.titleTag) {
              @case ('H1') {
                <h1><button ngbNavLink>{{item.title}}</button></h1>
              }
              @case ('H2') {
                <h2><button ngbNavLink>{{item.title}}</button></h2>
              }
              @default {
                <button ngbNavLink>{{item.title}}</button>
              }
            }
            <ng-template ngbNavContent>
              <app-custom-ohgar-tabs-item [item]="item"></app-custom-ohgar-tabs-item>
            </ng-template>
          </div>
        }
      </div>
    </div>
    <div [ngbNavOutlet]="nav" class="mt-2" (touchmove)="touchMove($event, items.length)"
    (touchstart)="startMove($event)"></div>
  }
}

